import React from 'react';
import { useTranslation } from 'react-i18next';
import { Platform } from 'react-native';

import { Box } from '@components/Restyle';
import Button from '@components/shared/Button/Button';
import Icon from '@components/shared/Icon/Icon';
import Text from '@components/Text/Text';
import { getScaledSize } from '@themes/theme';

type Props = {
  onPress?: () => void;
};

export const CompleteProfilePhoneBanner: React.FC<Props> = ({ onPress }) => {
  const { t } = useTranslation('models');

  return (
    <Box
      backgroundColor='black'
      borderRadius='xs'
      flexDirection={Platform.OS === 'web' ? 'row' : 'column'}
      alignItems='center'
      padding='s'>
      <Box flexDirection='row' style={Platform.OS === 'web' && { flex: 1 }}>
        <Box
          width={getScaledSize(40)}
          height={getScaledSize(40)}
          borderRadius='l'
          backgroundColor='greenDark'
          alignItems='center'
          justifyContent='center'
          marginRight='m'>
          <Icon name='Phone' variant='l' color='greenBrand' />
        </Box>
        <Box flex={1}>
          <Text variant='labelEmphasizedChatDetialTitle' color='white'>
            {t('profile.myAccount.completeProfileTitle')}
          </Text>
          <Text mt='xxs' variant='webBodyHintSubline' color='white'>
            {t('profile.myAccount.completeProfileDescription')}
          </Text>
        </Box>
      </Box>

      {onPress && (
        <Button
          marginTop={Platform.OS !== 'web' ? 'm' : 'none'}
          marginLeft='m'
          fullWidth={Platform.OS !== 'web'}
          width={Platform.OS === 'web' ? 150 : undefined}
          isSmall
          height={getScaledSize(48)}
          backgroundColor='greenSecondary'
          color='black'
          variant='webprimary'
          onPress={onPress}
          accessibilityLabel={t('profile.myAccount.addNow')}>
          <Text color='white' variant='webSmall'>
            {t('profile.myAccount.addNow')}
          </Text>
        </Button>
      )}
    </Box>
  );
};
